<template>
    <div class="p-30 page f-14">
        <el-form class="mb-30">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="试卷名称：" required>
                        <el-input v-model="paper.paperName" placeholder="请输入试卷名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="试卷分类：">
                        <el-cascader v-model="paper.categoryId" :options="paperCategory"
                            :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }"></el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-if="!reload">
            <div v-for="(g, i) in qGroupList" :key="i" class="pt-10 pb-10 pl-15 pr-15 bor-e9e9e9 mb-15">
                <div class="bg-e9e9e9 flex jc-sb p-15">
                    <div class="w-30p">
                        <el-input v-model="g.mainQuestionName" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="flex w-30p">
                        <div style="color: #F56C6C; margin-right: 4px">*</div>
                        <div>试题类型：</div>
                        <div class="flex-1">
                            <el-select :disabled="g.subQuestions && g.subQuestions.length > 0" v-model="g.topicType"
                                placeholder="请选择试题类型" clearable>
                                <el-option label="单选题" :value="1"></el-option>
                                <el-option label="多选题" :value="2"></el-option>
                                <el-option label="判断题" :value="3"></el-option>
                                <el-option label="填空题" :value="4"></el-option>
                                <el-option label="主观题" :value="5"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex w-30p jc-fe">
                        <div style="color: #F56C6C; margin-right: 4px">*</div>
                        <div>分数：</div>
                        <div class="flex-1 mr-5">
                            <el-input-number @change="scoreChange(g)" v-model="g.totalScore" :min="1"
                                label="请输入分数"></el-input-number>
                        </div>
                        <i @click="gUp(g)" class="el-icon-top bor-000 bor-r mr-5" :class="{ 'disable': i == 0 }"></i>
                        <i @click="gDown(g)" class="el-icon-bottom bor-000 bor-r mr-5"
                            :class="{ 'disable': i == qGroupList.length - 1 }"></i>
                        <i @click="gDel(g)" class="el-icon-delete"></i>
                    </div>
                </div>
                <qItem v-for="(q, i) in g.subQuestions" :key="i" :question="q" :group="g" :index="i"
                    @groupChange="groupChange"></qItem>
                <el-empty v-if="g.subQuestions && g.subQuestions.length == 0" description="暂无数据"></el-empty>
                <el-dropdown @command="addQuestion">
                    <el-button type="primary" plain icon="el-icon-plus">
                        从题库选择题目
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{ key: 1, g: g }">手动选题</el-dropdown-item>
                        <el-dropdown-item :command="{ key: 2, g: g }">固定抽题</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="ml-20 display-ib c-409eff" @click="addQGroup">
            <i class="el-icon-circle-plus-outline mr-5"></i>
            新增大题
        </div>
        <el-empty v-if="qGroupList && qGroupList.length == 0" description="暂无数据"></el-empty>
        <div class="flex jc-fe pb-20 mb-20">
            <div>
                <el-button type="primary" @click="save" plain>
                    保存试卷
                </el-button>
                <el-button type="danger" plain @click="cancel">
                    取消
                </el-button>
            </div>
        </div>

        <el-dialog title="添加试题" :visible.sync="addDialog" width="80%">
            <el-row class="mb-20">
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">试题内容：</div>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="stem" placeholder="" clearable></el-input>
                </el-col>
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">试题资源分类：</div>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="stem" placeholder="" clearable></el-input>
                </el-col>
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">试题难度：</div>
                </el-col>
                <el-col :span="5">
                    <el-select v-model="difficulty" placeholder="请选择难度" clearable>
                        <el-option label="简单" :value="1"></el-option>
                        <el-option label="普通" :value="2"></el-option>
                        <el-option label="困难" :value="3"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row class="mb-20">
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">试题标签：</div>
                </el-col>
                <el-col :span="5">
                    <el-select v-model="label" placeholder="请选择标签" clearable>
                        <el-option v-for="(o, i) in questionLabel" :key="i" :label="o.name" :value="o.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="3">
                    <div class="t-r pr-5 lh-32">操作时间：</div>
                </el-col>
                <el-col :span="5">
                    <el-date-picker v-model="qTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" format="yyyy-MM-DD HH:mm:ss" value-format="yyyy-MM-DD HH:mm:ss">
                    </el-date-picker>
                </el-col>
                <el-col :span="8">
                    <div class="flex jc-fe">
                        <el-button type="primary" @click="qSearch()">
                            <i class="el-icon-search" style="margin-right: 5px;"></i>查询
                        </el-button>
                        <el-button @click="qSearch('refresh')">
                            <i class="el-icon-refresh" style="margin-right: 5px;"></i>重置
                        </el-button>
                    </div>
                </el-col>
            </el-row>

            <dyTable v-loading="qLoading" ref="table" :columns="qColumns" :table-data="qList" :total="qTotal"
                :page-num="qPageNo" :page-size="qPageSize" @current-change="qPageNoChange" element-loading-text="加载中"
                @selection-change="qSelChange">
            </dyTable>

            <div class="flex jc-fe">
                <el-button type="primary" plain @click="qSave">确定</el-button>
                <el-button plain @click="() => addDialog = false">取消</el-button>
            </div>
        </el-dialog>

        <el-dialog v-loading="autoLoading" title="固定抽题" :visible.sync="autoDialog" width="60%">
            <div class="t-c f-16 fw-500 mb-20">您可通过设置抽题规则，点击开始抽题，从题库快速抽取题目填充至试卷中</div>
            <div class="f-18 fw-500 mb-20">筛选条件：</div>

            <el-row class="mb-20">
                <el-col :span="12">
                    <div class="flex jc-fs">
                        <!-- <div style="color: #F56C6C; margin-right: 4px">*</div> -->
                        <div>试题资源分类：</div>
                        <el-cascader v-model="aCategoryId" :options="questionCategory"
                            :props="{ expandTrigger: 'hover', emitPath: false, checkStrictly: true }"></el-cascader>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="flex jc-fs">
                        <!-- <div style="color: #F56C6C; margin-right: 4px">*</div> -->
                        <div>试题标签：</div>
                        <el-select v-model="label" placeholder="请选择标签" clearable>
                            <el-option v-for="(o, i) in questionLabel" :key="i" :label="o.name"
                                :value="o.id"></el-option>
                        </el-select>
                    </div>
                </el-col>
            </el-row>



            <div class="f-18 fw-500 mb-20">抽取设置：</div>
            <div class="mb-20 flex jc-fs">
                <div style="color: #f56c6c; margin-right: 4px">*</div>
                <div style="padding-bottom: 3px;">
                    抽题难度：
                </div>
                <el-radio-group v-model="difficultyType">
                    <el-radio :label="0">难度随机</el-radio>
                    <el-radio :label="1">难度有要求</el-radio>
                </el-radio-group>
            </div>
            <div class="mb-20 flex jc-fs ai-fs">
                <div class="flex" style="line-height: 32px;">
                    <div style="color: #f56c6c; margin-right: 4px">*</div>
                    <div>抽题数量：</div>
                </div>
                <el-input-number v-if="difficultyType == 0" v-model="num" :min="1"></el-input-number>
                <div v-if="difficultyType == 1">
                    <div class="mb-10">
                        简单
                        <el-input-number v-model="simpleNum"></el-input-number>
                    </div>
                    <div class="mb-10">
                        普通
                        <el-input-number v-model="ordinaryNum"></el-input-number>
                    </div>
                    <div class="mb-10">
                        困难
                        <el-input-number v-model="difficultNum"></el-input-number>
                    </div>
                </div>
            </div>
            <div class="flex jc-fe">
                <el-button type="primary" plain @click="autoConfirm">开始抽题</el-button>
                <el-button plain @click="() => autoDialog = false">取消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { paperEdit, questionList, paperInfo, autoSelQuestion, zgsourceAllCategory } from '@/api/index2';

import { watchArrayChange, cleanObject, generateUniqueString, uniqueArr, arrDelete } from '@/utils/utils';

import { encrypt, decrypt } from '@/api/common_encrypt';

import qItem from './components/qItem';
import dyTable from '@/components/common/dytable'
import paper from './route';


export default {
    name: 'paperDetail',
    components: {
        qItem,
        dyTable
    },
    computed: {

    },
    data() {
        return {
            loading: false,

            paperId: null,

            reload: false,

            tableLoading: false,
            addDialog: false,

            autoDialog: false,
            autoLoading: false,

            paper: {
                paperName: "",
            },


            questionLabel: [],
            label: null,

            qLoading: false,

            qSearchForm: {},
            stem: null,
            qCategoryId: null,
            difficulty: null,
            qTime: [],


            selGroup: {},

            qGroupList: [],
            qList: [],
            qSelList: [],
            _qSelList: [],

            qColumns: [],
            qPageNo: 1,
            qPageSize: 10,
            qTotal: 0,
            isEdit: false,



            aCategoryId: null,
            difficultyType: 0,
            num: 0,
            simpleNum: 0,
            ordinaryNum: 0,
            difficultNum: 0,


            paperCategory: [],
            questionCategory: [],

            isPlatform: false,
            isTem: false
        };
    },
    created() {
        let param = {}
        if (this.$route.query.param) {
            param = JSON.parse(decrypt(this.$route.query.param))
        }
        console.log('param :>> ', param);
        this.paper = param.paper || {};
        this.isEdit = param.isEdit || false;
        this.isPlatform = process.env.VUE_APP_SCHOOL_MODE == 'platform';

        if (this.paper && this.paper.id) {
            this.getPaperDetail();
        }
    },
    mounted() {
        this.getQuestionLabel();
        this.qColumns = [
            {
                type: 'selection',
                width: '55'
            },
            {
                type: 'index',
                title: '序号'
            },
            {
                key: 'stem',
                title: '试题内容'
            },
            {
                key: 'categoryName',
                title: '试题资源分类'
            },
            {
                key: 'difficulty',
                title: '难度',
                render: ({ row }) => {
                    return (
                        <div>
                            {row.difficulty == 1 && '简单'}
                            {row.difficulty == 2 && '普通'}
                            {row.difficulty == 3 && '困难'}
                        </div>
                    );
                }
            },
            {
                key: 'operatetime',
                title: '最后更新时间',
                render: ({ row }) => {
                    return (
                        <div>
                            {(new Date(row.operatetime).toLocaleString())}
                        </div>
                    );
                }
            },
            {
                key: 'schoolName',
                title: '所属学校/组织'
            }
        ];

        this.getCategory(3);
        this.getCategory(2);
    },

    active() {
        let param = {}
        if (this.$route.query.param) {
            param = JSON.parse(decrypt(this.$route.query.param))
        }
        console.log('param :>> ', param);
        this.paper = param.paper || {};
        this.isEdit = param.isEdit || false;
        this.isPlatform = process.env.VUE_APP_SCHOOL_MODE == 'platform';

        if (this.paper && this.paper.id) {
            this.getPaperDetail();
        }
    },

    methods: {
        async getQuestionLabel() {
            this.questionLabel = await this.$store.dispatch('label/getQuestionLabel');
        },
        back() {
            this.$router.go(-1);
        },
        getCategory(type) {
            let param = {
                type: type,
            }
            let arrName = type == 3 ? 'paperCategory' : 'questionCategory';
            zgsourceAllCategory(param).then((res) => {
                if (res.result == 1) {
                    this[arrName] = this.listFor(res.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },

        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },

        getPaperDetail() {
            this.loading = true;
            let param = {
                id: this.paper.id
            };
            console.log('paperInfo :>> ', param);
            paperInfo(param).then((res) => {
                console.log('paperInfo res :>> ', res);
                if (res.result == 1) {
                    this.paper = res.data;
                    this.qGroupList = [...this.paper.mainQuestions]
                    this.qGroupList.forEach(g => {
                        g.uKey = generateUniqueString();
                        g.subQuestions.forEach(q => {
                            // q.answer = JSON.parse(q.answer);
                            q.uKey = generateUniqueString();
                        })
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.loading = false;
            });

        },
        save() {
            if (!this.paper.paperName) {
                this.$message({
                    message: "请先输入试卷名称。",
                    type: 'error'
                });
                return
            }
            // else if (this.paper.categoryId == null) {
            //     this.$message({
            //         message: "请先选择试卷分类。",
            //         type: 'error'
            //     });
            //     return
            // } 
            else if (this.qGroupList.length == 0) {
                this.$message({
                    message: "请先添加大题。",
                    type: 'error'
                });
                return
            } else {
                let flag = true;
                for (let g of this.qGroupList) {
                    if (g.mainQuestionName == "") {
                        flag = false;
                        this.$message({
                            message: "请先输入大题名称。",
                            type: 'error'
                        });
                        break;
                    } else if (g.topicType == null) {
                        flag = false;
                        this.$message({
                            message: "请先选择该大题试题类型。",
                            type: 'error'
                        });
                        break;
                    } else if (g.totalScore == null) {
                        flag = false;
                        this.$message({
                            message: "请先输入该大题总分。",
                            type: 'error'
                        });
                        break;
                    } else if (g.subQuestions.length == 0) {
                        flag = false;
                        this.$message({
                            message: "请先添加小题。",
                            type: 'error'
                        });
                        break;
                    }

                    for (let q of g.subQuestions) {
                        if (q.score == null || q.score == 0) {
                            flag = false;
                            this.$message({
                                message: "请先输入该小题分数。",
                                type: 'error'
                            });
                            break;
                        }
                    }
                }


                if (!flag) {
                    return
                }
            }

            for (let g of this.qGroupList) {
                for (let q of g.subQuestions) {
                    q.questionId = q.questionId || q.id;
                }
            }
            this.loading = true;
            let param = {
                paperName: this.paper.paperName,
                categoryId: this.paper.categoryId,
                mainQuestions: this.qGroupList,
            };
            if (this.isEdit && this.paper && this.paper.id) {
                param.id = this.paper.id;
            }

            console.log(param);
            // return

            paperEdit(param).then((res) => {
                if (res.result == 1) {
                    this.$message({
                        showClose: true,
                        message: "保存成功",
                        type: 'success'
                    });
                    this.$router.replace('/paperList');
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.loading = false;
            });
        },

        cancel() {
            this.$router.replace('/paperList');
        },

        addQGroup() {
            this.qGroupList.push({
                uKey: generateUniqueString(),
                subQuestions: [],
            })
        },

        addQuestion(e) {
            this.getQuestionLabel();
            this.selGroup = { ...e.g };
            if (!e.g.topicType) {
                this.$message({
                    message: "请先选择该大题试题类型。",
                    type: 'error'
                });
                return
            }

            if (e.key == 1) {
                this.addDialog = true;
                this.qSearch("refresh");
            } else if (e.key == 2) {
                this.aCategoryId = null;
                this.label = null;
                this.difficultyType = 0;
                this.num = 0;
                this.simpleNum = 0;
                this.ordinaryNum = 0;
                this.difficultNum = 0;

                this.autoDialog = true;
            }
        },

        autoConfirm() {

            if (this.difficultyType == 0 && this.num == 0) {
                this.$message({
                    message: "请先输入抽题数量。",
                    type: 'error'
                });
                return
            } else if (this.difficultyType == 1 && (this.simpleNum + this.ordinaryNum + this.difficultNum) == 0) {
                this.$message({
                    message: "请先输入抽题数量。",
                    type: 'error'
                });
                return
            }
            // else if (!this.label || this.label == []) {
            //     this.$message({
            //         message: "请先选择试题标签。",
            //         type: 'error'
            //     });
            //     return
            // }

            // else if (this.qCategoryId == null) {
            //     this.$message({
            //         message: "请先选择试题资源分类。",
            //         type: 'error'
            //     });
            //     return
            // }

            let param = {
                categoryId: this.qCategoryId,
                difficultyType: this.difficultyType,
                topicType: this.selGroup.topicType,
            };
            if (this.label) {
                param.label = [this.label]
            }
            if (this.difficultyType == 0) {
                param = {
                    ...param,
                    num: this.num,
                }
            } else if (this.difficultyType == 1) {
                param = {
                    ...param,
                    simpleNum: this.simpleNum,
                    ordinaryNum: this.ordinaryNum,
                    difficultNum: this.difficultNum,
                }
            }
            console.log('param :>> ', param);
            this.autoLoading = true;

            autoSelQuestion(cleanObject(param)).then((res) => {
                if (res.result == 1) {
                    for (let q of res.data) {
                        q.uKey = generateUniqueString();
                    }
                    this.qGroupList.forEach(item => {
                        if (item.uKey === this.selGroup.uKey) {
                            let arr = [...item.subQuestions, ...res.data];
                            item.subQuestions = uniqueArr(arr, "stem");
                            this.scoreChange(item)
                        }
                    });

                    this.autoDialog = false;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }

                this.autoLoading = false;
            });

        },

        qPageNoChange(val) {
            this.qPageNo = val;
            this.qGetList();
        },

        qSearch(msg) {
            this.qPageNo = 1;
            this.qSearchForm = {
                stem: this.stem,
                categoryId: this.qCategoryId,
                difficulty: this.difficulty,
                from: this.qTime[0],
                to: this.qTime[1],
            }
            if (this.label) {
                this.qSearchForm.label = [this.label];
            }
            if (msg == "refresh") {
                this.qSearchForm = {}
                this.stem = null;
                this.qCategoryId = null;
                this.difficulty = null;
                this.label = null;
                this.qTime = [];
            }
            this.qGetList()
        },

        qGetList() {
            this.qLoading = true;

            let param = {
                topicType: this.selGroup.topicType,
                page: this.qPageNo,
                pageSize: this.qPageSize,
                ...this.qSearchForm,
            }

            console.log('param :>> ', param);
            questionList(cleanObject(param)).then((res) => {
                console.log('res :>> ', res);
                if (res.result == 1) {
                    this.qTotal = res.data.total;
                    this.qPageNo = res.data.pageNum;
                    this.qList = res.data.list;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.qLoading = false;
            });
        },

        qSelChange(val) {
            this.qSelList = val;
            let arr = watchArrayChange(val, this._qSelList, 'id')
        },

        qSave() {
            for (let q of this.qSelList) {
                // q.answer = JSON.parse(q.answer);
                q.uKey = generateUniqueString();
            }
            let g = {};
            this.qGroupList.forEach(item => {
                if (item.uKey === this.selGroup.uKey) {
                    let arr = [...item.subQuestions, ...this.qSelList];
                    item.subQuestions = uniqueArr(arr, "stem");
                    this.scoreChange(item)
                }
            });
            console.log('1111 :>> ', 1111);
            this.addDialog = false;
        },

        gDel(g) {
            this.qGroupList = arrDelete(this.qGroupList, "uKey", g.uKey)
        },

        gUp(g) {
            const index = this.qGroupList.findIndex(item => item.uKey === g.uKey);
            if (index > 0) {
                const temp = this.qGroupList[index - 1];
                this.qGroupList[index - 1] = this.qGroupList[index];
                this.$set(this.qGroupList, index, temp);
            }
        },
        gDown(g) {
            const index = this.qGroupList.findIndex(item => item.uKey === g.uKey);
            if (index < this.qGroupList.length - 1) {
                const temp = this.qGroupList[index + 1];
                this.qGroupList[index + 1] = this.qGroupList[index];
                this.$set(this.qGroupList, index, temp);
            }
        },

        groupChange(group) {
            const index = this.qGroupList.findIndex(item => item.uKey === group.uKey);
            if (index !== -1) {
                this.$nextTick(() => {
                    this.$set(this.qGroupList, index, group);
                    this.$forceUpdate();
                })
                this.reload = true;
                setTimeout(() => {
                    this.reload = false;
                }, 0);
            }
        },

        scoreChange(g) {
            const n = g.subQuestions.length;
            const ts = g.totalScore;
            const es = Math.floor(ts / n);
            const rs = ts % n;
            g.subQuestions.forEach((q, i) => {
                q.score = es + (i === n - 1 ? rs : 0);
            });
            this.groupChange(g)
        },
    }
};
</script>

<style lang='scss' scoped>
i.disable {
    color: #ccc;
    border-color: #ccc;
}
</style>
